import { Button, Img, Slider, Heading } from "../../../components";
import UserProfile from "../../../components/UserProfile";
import React, { useState } from "react";
import AliceCarousel, { EventObject } from "react-alice-carousel";
import { useTranslation } from "react-i18next";

export default function ExamplesSection() {
    const [sliderState, setSliderState] = React.useState(0);
    const sliderRef = React.useRef<AliceCarousel>(null);
    const { t } = useTranslation();

    const [showAll, setShowAll] = useState(false);

    const itemsData = [
        {
            userAvatar: "/images/CompanyOwner.png",
            userName: t("review.user_name.1"),
            userPosition: t("review.position.1"),
            feedbackDate: t("review.review_date.1"),
            button: t("review.button"),
            button_collapse: t("review.button_collapse"),
            requestDescription: t("review.review_text.1"),
            feedbackNumber: "1/3",
        },
        {
            userAvatar: "/images/CEOImage.png",
            userName: t("review.user_name.2"),
            userPosition: t("review.position.2"),
            feedbackDate: t("review.review_date.2"),
            button: t("review.button"),
            button_collapse: t("review.button_collapse"),
            requestDescription: t("review.review_text.2"),
            feedbackNumber: "2/3",
        },
        {
            userAvatar: "/images/CDTOImage.png",
            userName: t("review.user_name.3"),
            userPosition: t("review.position.3"),
            feedbackDate: t("review.review_date.3"),
            button: t("review.button"),
            button_collapse: t("review.button_collapse"),
            requestDescription: t("review.review_text.3"),
            feedbackNumber: "3/3",
        },
    ];

    const itemsToShow = showAll ? itemsData : itemsData.slice(0, 1);

    const [expandedStates, setExpandedStates] = React.useState(
        Array(itemsData.length).fill(false)
    );

    const toggleExpanded = (index: number) => {
        setExpandedStates((prev) =>
            prev.map((val, i) => (i === index ? !val : val)) // Меняем только состояние отзыва по индексу
        );
    };

    const sliderItems = itemsData.map((data, index) => (
        <div className="flex md:flex-col items-start pr-[20px] h-auto" key={index}>
            <div className="w-full">
                <UserProfile
                    button={""} button_collapse={""} {...data}
                    isExpanded={expandedStates[index]} // Используем состояние для каждого отзыва
                    onToggle={() => toggleExpanded(index)} // Функция для переключения состояния
                    className="w-full"
                />
            </div>
        </div>
    ));

    return (
        <>
            <section id="Examples"></section>
            <div className="max-w-[1440px] mx-auto px-6">
                <div className="flex items-center justify-between max-w-[1440px]">
                    <div className="flex flex-col items-start">
                        <Heading
                            size="desktop_heading_4"
                            as="h2"
                            className=" font-medium text-[#191c2fe5] leading-[33.6px] gap-4 ml-2 uppercase"
                        >
                            {t("review.head_title")}
                        </Heading>
                    </div>

                    <div className="flex gap-4 ">
                        <Button
                            onClick={() => sliderRef.current?.slidePrev()}
                            className="w-[56px] h-[56px] flex items-center justify-center rounded-[12px] bg-[#6C6C6C] hover:bg-[#0C88F0]"
                        >
                            <Img src="/images/left_arrow_white.svg" alt="Prev" className="h-[24px]" />
                        </Button>
                        <Button
                            onClick={() => sliderRef.current?.slideNext()}
                            className="w-[56px] h-[56px] flex items-center justify-center rounded-[12px] bg-[#6C6C6C] hover:bg-[#0C88F0]"
                        >
                            <Img src="/images/right_arrow_white.svg" alt="Next" className="h-[24px]" />
                        </Button>
                    </div>
                </div>

                <div className="w-full mt-10 overflow-visible ">
                    <div className="flex w-full">
                        <Slider
                            autoPlay
                            autoPlayInterval={500000}
                            responsive={{
                                "0": { items: 1 },
                                "551": { items: 1 },
                                "1024": { items: 2 },
                                "1441": { items: 2 },
                            }}
                            disableDotsControls
                            activeIndex={sliderState}
                            onSlideChanged={(e: EventObject) => {
                                setSliderState(e.item);
                            }}
                            ref={sliderRef}
                            items={sliderItems}
                            paddingRight={20}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
